exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".min-input-class[data-v-03d4f3de]{min-height:25px;border-bottom:1px dotted #b0b1b3}", ""]);

// exports
